/**
 * (Группа 7) Управление capability отелей.
 *
 * TODO backend: PATCH /v1/admin/tenants/{id}/capabilities (с обязательной
 * причиной) и GET .../capabilities/history отсутствуют. UI-каркас готов.
 */
import { PageStub } from '../../shared/PageStub.js';

export function CapabilitiesPage(): JSX.Element {
  return (
    <PageStub
      testId="capabilities-page"
      title="Управление capability"
      description="Переключение 12 возможностей отеля с обязательной причиной и записью в аудит-цепочку."
      sections={[
        'Модальное окно переключателей (12 capability)',
        'Обязательное поле причины (≥10 символов)',
        'История изменений capability: actor, причина, время',
      ]}
      dataSource="TODO backend: PATCH .../capabilities + GET .../capabilities/history"
    />
  );
}
